import React, { useState, useEffect } from "react";
import { migrerPraticien, getFinessInformation } from "./Fonctions_Communications_API";
import "../css/PopUpJetonAcces.css";

const ModalMigrationPraticien = ({ etablissement, personne, afficherModalMigrationPraticiens, setAfficherModalMigrationsPraticiens }) => {
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const [nouveauNumeroFiness, setNouveauNumeroFiness] = useState("");
  const [supprimerPraticien, setSupprimerPraticien] = useState(false);
  const [infoNouvelEtablissement, setInfoNouvelEtablissement] = useState(null);
  const [confirmationSuppression, setConfirmationSuppression] = useState(false);
 
  // Vérification des informations du nouvel établissement
  const handleVerifierEtablissement = async () => {
    if (nouveauNumeroFiness.trim() !== "") {
      await getFinessInformation(nouveauNumeroFiness.trim(), setInfoNouvelEtablissement);
    
    } else {
      alert("Veuillez entrer un numéro de FINESS.");
    }
  };

  // Gérer la migration ou la suppression du praticien
  const handleMigrerPraticien = async () => {
    if (!supprimerPraticien && nouveauNumeroFiness.trim() === "") {
      alert("Veuillez entrer un numéro de FINESS ou sélectionner la suppression.");
      return;
    }

    const newFiness = supprimerPraticien ? null : nouveauNumeroFiness.trim();
    await migrerPraticien(etablissement.finess_et, personne.rpps_id, newFiness);
    setInfoNouvelEtablissement(null);
    setNouveauNumeroFiness("");
    setAfficherModalMigrationsPraticiens(false);
    setShowWelcomePopup(true);
  };



  const handleChangeNumeroFiness = (e) => {
    const value = e.target.value; 
    setNouveauNumeroFiness(value);
  };

  useEffect(() => {
    if (nouveauNumeroFiness.length === 9) {
      handleVerifierEtablissement();
    }
    else {
      setInfoNouvelEtablissement(null);
    }
  }, [nouveauNumeroFiness]);

  if (!afficherModalMigrationPraticiens && !showWelcomePopup) return null;

  return (
    <>
      {afficherModalMigrationPraticiens && (
        <div className="jetonacces-overlay">
          <div className="jetonacces-container" style={{ width: "400px" }}>
            <h2 className="jetonacces-title">{personne.prenom} {personne.nom} n'exerce plus ici ?</h2>

            {/* Option de suppression */}
            <div className="jetonacces-options">
              <label className="checkbox-label">
                <input 
                  type="checkbox" 
                  checked={supprimerPraticien} 
                  onChange={() => {
                    setSupprimerPraticien(!supprimerPraticien);
                    setNouveauNumeroFiness("");
                    setInfoNouvelEtablissement(null);
                  }} 
                />
                <span>Supprimer ce praticien s'il n'exerce plus ici</span>
              </label>
            </div>

            {/* Saisie du nouveau FINESS si non supprimé */}
            {!supprimerPraticien && (
              <>
                <input
                  type="text"
                  maxLength={9}
                  placeholder="Numéro de FINESS-ET du nouvel établissement"
                  value={nouveauNumeroFiness}
                  onChange={handleChangeNumeroFiness}
                  className="jetonacces-input"
                  style={{marginTop:'20px'}}
                />
                
              </>
            )}

            
          {infoNouvelEtablissement && (
            <div className="etablissement-info">
              <h3>Nouvel établissement trouvé :</h3>
              
              <div className="etablissement-detail">
              <img src={`marqueurs_finaux_finess/${infoNouvelEtablissement.sous_categorie}.png`} alt="Nom" />


                <p>{infoNouvelEtablissement.rs}</p>
              </div>

              <div className="etablissement-detail">
                <img src="adresse.png" alt="Adresse" />
                <p>{infoNouvelEtablissement.adresse_finale}</p>
              </div>

              <div className="etablissement-detail">
                <img src={`logos_marianne_PS/${personne.profession}.png`} alt="Ville" />
                <p>{personne.profession}</p>
              </div>
            </div>
          )}


           
            {supprimerPraticien && !confirmationSuppression ? (
              <>
                <p className="warning-text">
                  ⚠️ Attention, vous vous apprêtez à supprimer ce praticien de cet établissement.  
                  Si vous connaissez son nouvel établissement, n'hésitez pas à l'y ajouter !
                </p>
                <button onClick={() => setConfirmationSuppression(true)} className="jetonacces-bouton check" style={{marginTop:'20px'}}>
                  Confirmer la suppression
                </button>
              </>
            ) : (
              <div className="jetonacces-boutons">
                <button onClick={() => {setAfficherModalMigrationsPraticiens(false);setNouveauNumeroFiness("")}} className="jetonacces-bouton cancel">Annuler</button>
                <button 
                  disabled={!infoNouvelEtablissement && !supprimerPraticien} // Désactivé si null ou undefined
                  onClick={handleMigrerPraticien} 
                  className={`jetonacces-bouton submit ${(!infoNouvelEtablissement&& !supprimerPraticien) ? 'disabled-button' : ''}`}
                  title={(!infoNouvelEtablissement&& !supprimerPraticien) ? "Veuillez d'abord sélectionner un établissement" : ""}
                >
                  Valider
                </button>              
              </div>
            )}
          </div>
        </div>
      )}

      {/* Message de confirmation après action */}
      {showWelcomePopup && (
        <div className="welcome-overlay">
          <div className="welcome-container">
            <h2 className="welcome-title">Merci pour votre aide</h2>
            <p style={{ fontFamily: 'Interfont', color: "#190b34", fontStyle: 'italic' }}>
              Les informations du praticien ont été mises à jour avec succès.
            </p>
            <button onClick={() => setShowWelcomePopup(false)} className="welcome-bouton">Fermer</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalMigrationPraticien;
